import React from 'react';
import cx from 'classnames';
import styles from './Loading.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

const Loading = props => {
  const { size, padding, className } = props;

  return (
    <div className={ cx(styles.loadingWrapper, className) } style={{ padding: padding}}>
      <FontAwesomeIcon
        icon={ fas.faSpinner }
        size={ size }
        spin
      />
    </div>
  );
};

Loading.defaultProps = {
  size: 'lg',
  padding: null
};


export default Loading;
